<template>
    <div style="font-family: monospace;" class="e2e-server-error">  
        <h5>Message:</h5>
        <pre><code>{{fragment.message}}</code></pre>
        <h5>Line:</h5>
        <pre><code>{{fragment.line}}</code></pre>
        <h5>Exception:</h5>
        <pre><code>{{fragment.exception}}</code></pre>
        <h5>Stacktrace:</h5>
        <ul style="margin: 0;">
            <li v-for="(st,i) in fragment.stacktrace" :key="i"> 
                <pre><code>{{st}}</code></pre>
            </li>
        </ul>
        <hr>
    </div>
</template>

<script>
/**
 * fragment =  {
 *    "uiType" : "...",
 *    "exception":"de.htwsaar.groovy.TraceableException",
 *    "message":"jsteuer/lti:55:Variable 'Widgets' is not defined.",
 *    "stacktrace":["jsteuer/lti:55","jsteuer/lti:-1"],
 *    "cause":null,
 *    "line":55,
 *    "path":"jsteuer/lti"
 * }
 */
export default {
  name: "fragment-server-error",
  props: ["fragment"]
} ;
</script>
 

<style scoped>
pre {
  margin: 0; 
}
code{
    white-space: pre-wrap;       /* Since CSS 2.1 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
}
</style>